import { render, staticRenderFns } from "./MesaDelegacionesVecinoNewOrEdit.vue?vue&type=template&id=7820ffcc"
import script from "./MesaDelegacionesVecinoNewOrEdit.vue?vue&type=script&lang=js"
export * from "./MesaDelegacionesVecinoNewOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports